import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
  },
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        primary: {
          base: "#1f1d1d",
          lighten2: "#2a2828",
          lighten3: "#343233",
          darken4: "#050505",
        },
        secondary: "#ed3237",
      },
    },
  },
});
